export function regExpToPatternString(pattern: RegExp | null) {
    if (pattern?.toString()) {
        return pattern.toString().replace(/[.*+?^${}()|[\]\\]/g, '\\$&').slice(1, -1);
    }

    return null;
}

export function slugifyString(str: string) {
    return str.toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '') // Remove special characters
        .replace(/\s+/g, '-')         // Replace spaces with hyphens
        .replace(/-+/g, '-');         // Replace multiple hyphens with a single hyphen
}

export function encodeBase64(str: string) {
    const utf8Bytes = new TextEncoder().encode(str);
    const base64String = btoa(String.fromCharCode(...utf8Bytes));
    return base64String;
};

export function getFocusableElements($el: HTMLElement, renderedOnly = true) {
    function elementIsRendered($el: HTMLElement) {
        return !!($el.offsetWidth || $el.offsetHeight || $el.getClientRects().length);
    }

    const $all = $el.querySelectorAll('a[href], button:not([disabled])') as NodeListOf<HTMLElement>;
    const $rendered = Array.from($all).filter($el => elementIsRendered($el));
    const $elements = renderedOnly ? $rendered : $all;

    return {
        all: $elements,
        first: $elements[0] as HTMLElement,
        last: $elements[$elements.length - 1] as HTMLElement,
    }
}
